"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertToApiFilters = exports.convertToApiSorts = exports.convertToTableSorts = exports.useTableData = void 0;
const react_1 = require("react");
const common_types_1 = require("../../../common/common-types");
const event_callback_hook_1 = require("../../../utils/event-callback-hook");
const first_render_1 = require("../../../utils/first-render");
const update_effect_1 = require("../../../utils/update-effect");
const force_render_1 = require("../../../utils/force-render");
const evidence_defaults_context_1 = require("../../evidence-defaults/evidence-defaults-context");
function useTableData({ source, searchQuery, sorts, preFilters, filters, filtersState, advancedFilters, include, loaderRef, }) {
    const { forceRender } = force_render_1.useForceRender();
    const { sortMissingValues } = react_1.useContext(evidence_defaults_context_1.EvidenceDefaultsContext);
    const setSourceParams = event_callback_hook_1.useEventCallback(() => {
        const filtersWithState = filters.map((filter, i) => ({ ...filter, ...filtersState[i] }));
        source.setParams({
            sort: convertToApiSorts(sorts, sortMissingValues),
            filters: convertToApiFilters(preFilters, filtersWithState, advancedFilters, searchQuery),
            include: include,
            size: 30,
        });
    });
    first_render_1.useFirstRender(() => {
        setSourceParams();
    });
    update_effect_1.useUpdateEffect(() => {
        setSourceParams();
        source.reset();
        forceRender();
        requestAnimationFrame(() => {
            var _a;
            (_a = loaderRef.current) === null || _a === void 0 ? void 0 : _a.resetloadMoreItemsCache(true);
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [searchQuery, sorts, preFilters, filtersState, include, advancedFilters]);
}
exports.useTableData = useTableData;
function convertToTableSorts(sorts) {
    return sorts.map((sort) => ({
        datakey: sort.field,
        field: sort.field,
        type: sort.type,
        order: sort.order,
    }));
}
exports.convertToTableSorts = convertToTableSorts;
function convertToApiSorts(sorts, sortMissingValues = 'LAST') {
    return sorts.map((sort) => {
        let missing = 'LAST';
        if (sortMissingValues === 'FIRST_ON_ASC' && sort.order === 'ASC') {
            missing = 'FIRST';
        }
        if (sortMissingValues === 'FIRST_ON_DESC' && sort.order === 'DESC') {
            missing = 'FIRST';
        }
        if (sortMissingValues === 'FIRST') {
            missing = 'FIRST';
        }
        return {
            field: sort.field,
            order: sort.order,
            type: sort.type,
            missing,
        };
    });
}
exports.convertToApiSorts = convertToApiSorts;
/**
 * Translares table filters to api filters.
 *
 * Combines pre-filters, table filters with search query, removes disabled or empty filters
 * @param preFilters
 * @param filters
 * @param searchQuery
 */
function convertToApiFilters(preFilters, filters, advancedFilters, searchQuery) {
    const apiFilters = filters
        .filter((filter) => filter.enabled)
        .filter(filterEmptyFilter)
        .map((filter) => {
        const { operation, filterkey, value, filters, asciiFolding } = filter;
        return {
            field: filterkey,
            operation: operation,
            value,
            filters,
            asciiFolding,
        };
    });
    if (searchQuery !== '') {
        apiFilters.push({
            field: '',
            operation: common_types_1.ApiFilterOperation.FTX,
            value: searchQuery,
        });
    }
    apiFilters.push(...advancedFilters);
    if (preFilters.length) {
        apiFilters.push(...preFilters.filter(({ value, operation, filters }) => !!value ||
            ([
                common_types_1.ApiFilterOperation.OR,
                common_types_1.ApiFilterOperation.AND,
                common_types_1.ApiFilterOperation.NOT,
            ].includes(operation) &&
                (filters !== null && filters !== void 0 ? filters : []).length > 0)));
    }
    return apiFilters;
}
exports.convertToApiFilters = convertToApiFilters;
function filterEmptyFilter({ value, operation }) {
    if (value == null && operation === common_types_1.ApiFilterOperation.EQ) {
        return false;
    }
    return true;
}
//# sourceMappingURL=table-data-hook.js.map